import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AutoImporter } from './AutoImporters';
import { FindContent } from './FindContent';
import { NotFoundRedirect } from '../App/NotFoundRedirect';
import { CsvImporter } from './CsvImporter';
import classes from './Discover.module.scss';
import { ChromeExtension } from './ChromeExtension';

export const DiscoverView = (): JSX.Element => {
  return (
    <div className={classes.Discover}>
      <Routes>
        <Route path={'find'} element={<FindContent />} />
        <Route path={'auto'} element={<AutoImporter />} />
        <Route path={'importer'} element={<CsvImporter />} />
        <Route path={'extension'} element={<ChromeExtension />} />
        <Route path={'/'} element={<Navigate to={'find'} replace />} />
        <Route path={'*'} element={<NotFoundRedirect to={'find'} />} />
      </Routes>
    </div>
  );
};
